import { ApplicationState } from 'app/types-store';

export const selectFetchingLinks = (state: ApplicationState) =>
  state.linksSection?.fetchingLinksGroups;

export const selectLinks = (state: ApplicationState) =>
  state.linksSection?.linksGroups;
